<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2026-05-07 14:01:40
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\components\WorkFlow\OperationModal.vue
-->
<!--
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-11-17 09:20:38
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-12 16:44:59
-->
<template>
  <section>
    <el-dialog v-dialogDrag :visible.sync="showSendVisible" width="500px" :before-close="handleCancel">
      <span slot="title">审批结果</span>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="审批结果" prop="approvalStatus">
          <el-select v-model="form.approvalStatus" placeholder="请选择活动区域" style="width:100%;">
            <el-option label="同意" value='2'></el-option>
            <el-option label="不同意" value='3'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见">
          <el-input v-model="form.approvalOptions" type="textarea" rows='4'></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" size="medium" @click="handleCancel">取 消</el-button>
        <el-button class="bottom_all" style="margin-left:24px" size="medium" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
export default {
  props: ['showSendVisible'],
  data() {
    return {
      form: {
        approvalOptions: '',
        approvalStatus: '2'
      },
      rules: {
        approvalStatus: [
          { required: true, message: '请选择审批意见', trigger: 'change' }
        ],
      },
    }
  },
  methods: {
    //设置默认审批意见
    setOperationModal(approvalOptions){
      this.form.approvalOptions = approvalOptions
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
    handleSure() {
      console.log('1111111111111111')
      this.$emit('handleSure', this.form);
    },
  }
}
</script>
<style scoped>
</style>
